import React from 'react';
import { Auth } from 'aws-amplify';
import { Link, NavLink } from 'react-router-dom';
import { Navbar, Nav, NavDropdown, Row, Col } from 'react-bootstrap';
import { useAppContext } from '../libs/contextLib';
import { userStates } from '../libs/userLib';
import { useMatomo } from '@jonkoops/matomo-tracker-react';
import Help from './Help';
import './Navigation.scss'
import { ReactComponent as Logo } from '../assets/logo.svg';
import { ReactComponent as Instagram } from '../assets/icons/instagram.svg';
import { ReactComponent as Facebook } from '../assets/icons/facebook.svg';
import { ReactComponent as Twitter } from '../assets/icons/twitter.svg';
import config from '../config';


export default function Navigation({
  ...props
}) {
  const { userState } = useAppContext();
  const { user }      = useAppContext();
  const { trackLink } = useMatomo();
  const showSocials   = false;
  const socialSize    = '1.5em'

  function getEnvironmentText() {
    const envCapitalised = typeof process.env.REACT_APP_STAGE === 'undefined' ?
      "TESTING" : process.env.REACT_APP_STAGE.toUpperCase();
    return envCapitalised === "PRODUCTION" ? "" : `Gateway - ${envCapitalised}`;
  }

  async function handleLogout() {
    await Auth.signOut();
  }

  function outlink(link) {
    trackLink({href: link, linkType: 'link'});
    window.location = link;
  }

  // Return an empty component if there are no errors.
  return (
    <div className='container my-3'>

      <Navbar expand="md" collapseOnSelect bg="bg-white" variant="light">
        <Navbar.Brand as={Link} to="/">
          <Row>
            <Col>
              <Logo
                style={{width:"300px", height: "fit-content"}}
                className="d-inline-block align-top logo ps-2"
                alt="Cirencester Friendly"
              />
            </Col>
            <Col className="my-auto">
              { getEnvironmentText() }
            </Col>
          </Row>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto" />
          <Nav>
            <Nav.Item>
              <Nav.Link
                onClick={() => outlink(config.links.menuHome)}
                href={config.links.menuHome}
              >
                Home
              </Nav.Link>
            </Nav.Item>
            {
              userState === userStates.CONFIRMED ? (
                <>
                  {/* SIGNED IN USER */}
                  <Nav.Item>
                    <Nav.Link
                      as={NavLink}
                      exact="true"
                      to="/"
                    >
                      Gateway
                    </Nav.Link>
                  </Nav.Item>
                  <NavDropdown title={user === null ? 'Log in' : 'User'} id="user-dropdown">
                    <NavDropdown.Item
                      as={NavLink}
                      exact="true"
                      to="/user"
                    >
                      Profile
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      onClick={handleLogout}
                    >
                      Logout
                    </NavDropdown.Item>
                  </NavDropdown>
                  
                </>
              ) : (
                <>
                  {/* NON-SIGNED IN USER */}
                  {/*}
                  <Nav.Item>
                    <Nav.Link as={NavLink} to="/register">Register</Nav.Link>
                  </Nav.Item>
                  */}
                  <Nav.Item>
                    <Nav.Link as={NavLink} to="/login">Gateway</Nav.Link>
                  </Nav.Item>
                </>
              )
            }
            <Nav.Item className="px-1">
              <Help />
            </Nav.Item>
            {
              showSocials ? (
                <>
                  <Nav.Item className="px-1">
                    <Instagram 
                      onClick={() => outlink(config.links.instagram)}
                      href={config.links.instagram}
                      style={{ height: socialSize, width: socialSize, position: "relative", top: "0.35em", cursor: 'pointer' }}
                      alt = 'instagram'
                    />
                  </Nav.Item>
                  <Nav.Item className="px-1">
                    <Facebook
                      onClick={() => outlink(config.links.facebook)}
                      href={config.links.facebook}
                      style={{ height: socialSize, width: socialSize, position: "relative", top: "0.35em", cursor: 'pointer' }}
                      alt = 'facebook'
                    />
                  </Nav.Item>
                  <Nav.Item className="px-1">
                    <Twitter
                      onClick={() => outlink(config.links.twitter)}
                      href={config.links.twitter}
                      style={{ height: socialSize, width: socialSize, position: "relative", top: "0.35em", cursor: 'pointer' }}
                      alt = 'twitter'
                    />
                  </Nav.Item>
                </>
              ) : null
            }
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  )
}